
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { CustomFieldDto, CustomFieldTypes, CustomFieldValues } from "@/store/custom-fields/types";
import { truncateString } from "@/filters";
import IconUpload from "@/components/IconUpload.vue";
import CustomFieldDatePicker from "@/components/custom-fields/CustomFieldDatePicker.vue";
import { customFieldMixins } from "@/mixins/customFieldMixins";

const { convertCustomFieldDateValue } = customFieldMixins.methods;

@Component({
	filters: { truncateString },
	components: {
		"icon-upload": IconUpload,
		"custom-field-date-picker": CustomFieldDatePicker
	}
})

export default class CustomDefinedField extends Vue {
	@Prop({ type: Object, required: true }) public value: CustomFieldValues;
	@Prop({ type: Object, required: true }) public setting: CustomFieldDto;
	@Prop({ type: Number, default: 250 }) public maxCharacters: number;

	private type: string;

	@Watch("type")
	private beforeMount(): void {
		this.type = CustomFieldTypes[this.setting?.customFieldTypeId];
	}

	private get checkboxValue(): boolean {
		return this.value.value == "true" ? true : false;
	}

	private isCustomFieldTypeTextOrTextArea(customFieldType: string): boolean {
		return customFieldType == 'Text' || customFieldType == 'TextArea' || customFieldType == 'Number';
	}

	private getConvertedCustomFieldDateValue(date: string): string {
		return convertCustomFieldDateValue(date);
	}

	private isType(customFieldType: string): boolean {
		if (!(customFieldType in CustomFieldTypes)) {
			return false;
		}

		return this.type?.toLowerCase() === customFieldType?.toLowerCase();
	}
}
